import { FormEvent, ReactNode, useEffect, useState } from 'react';
import { supabase } from './lib/supabase';

export default function PasswordRecoveryGate({children}:{children:ReactNode}){
  const [active,setActive]=useState(false);
  const [checking,setChecking]=useState(false);
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  const [message,setMessage]=useState('');

  useEffect(()=>{
    if(!supabase) return;
    let mounted=true;
    const requested=new URLSearchParams(window.location.search).get('password-recovery')==='1';
    if(requested){
      setChecking(true);
      supabase.auth.getSession().then(({data})=>{
        if(!mounted) return;
        if(data.session) setActive(true);
        setChecking(false);
      });
    }
    const {data:listener}=supabase.auth.onAuthStateChange((event)=>{
      if(event==='PASSWORD_RECOVERY'){
        setActive(true);
        setChecking(false);
      }
    });
    return ()=>{mounted=false;listener.subscription.unsubscribe()};
  },[]);

  async function updatePassword(event:FormEvent<HTMLFormElement>){
    event.preventDefault();
    if(!supabase) return;
    const form=new FormData(event.currentTarget);
    const password=String(form.get('password')||'');
    const confirm=String(form.get('confirm')||'');
    setError('');setMessage('');
    if(password.length<8){setError('Use at least 8 characters.');return;}
    if(password!==confirm){setError('The passwords do not match.');return;}
    setBusy(true);
    const {error:updateError}=await supabase.auth.updateUser({password});
    setBusy(false);
    if(updateError){setError(updateError.message);return;}
    setMessage('Password updated successfully.');
  }

  function continueToMarineOps(){
    const url=new URL(window.location.href);
    url.searchParams.delete('password-recovery');
    window.history.replaceState({},'',`${url.pathname}${url.search}${url.hash}`);
    setActive(false);setMessage('');setError('');
  }

  if(checking&&!active) return <RecoveryShell><h1>Opening secure reset link</h1><p className="auth-copy">Verifying your password recovery session…</p></RecoveryShell>;
  if(!active) return <>{children}</>;

  return <RecoveryShell>
    <p className="eyebrow">Account recovery</p>
    <h1>Choose a new password</h1>
    <p className="auth-copy">Set a new MarineOps password for this account. Aqua Operations cannot see your password.</p>
    {message?<><div className="auth-alert success">{message}</div><button className="primary-button auth-submit" onClick={continueToMarineOps}>Continue to MarineOps</button></>:<form className="auth-form" onSubmit={updatePassword}>
      <label>New password<input name="password" type="password" minLength={8} autoComplete="new-password" required/></label>
      <label>Confirm new password<input name="confirm" type="password" minLength={8} autoComplete="new-password" required/></label>
      {error&&<div className="auth-alert error">{error}</div>}
      <button className="primary-button auth-submit" disabled={busy}>{busy?'Updating…':'Update password'}</button>
    </form>}
  </RecoveryShell>;
}

function RecoveryShell({children}:{children:ReactNode}){
  return <div className="auth-shell"><div className="auth-shade"/><section className="auth-card compact-card"><div className="auth-brand"><span>A</span><div><strong>MarineOps</strong><small>aqua-operations.com</small></div></div>{children}</section></div>;
}
